import axios from "axios";
const qs = require("qs");

const base_url = 'https://zzb.api.hainanbus.com';
// const base_url = 'http://127.0.0.1:9996';
const common_path = "/api/v1/pad";

import AdminToken from '@/common/AdminToken';

const $http = axios.create({
    baseURL: base_url + common_path,
    method: "post",
    // withCredentials: true, //带COOKIE
    transformRequest:[function(data = {}){
        var flag = data instanceof FormData;
        data = !flag ? qs.stringify(data) : data;

        return data;
    }]
});
$http.base_url = base_url;
$http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';  //post请求默认content-type;

$http.file = function(url, data){
    return $http({
        url: base_url + common_path + url,
        data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}
// 添加拦截器为所有请求添加token
$http.interceptors.request.use(function(config){
    config['headers']['Admin-Token'] = (new AdminToken).getToken();

    var params = { XDEBUG_SESSION_START: 13118,};
    config.params = Object.assign(params, config.params)
    return config;
});
import { Notify } from 'vant';

//全局错误处理
$http.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    var msg = error.response.data.msg;
    Notify({message: msg})
})

export default $http;



// WEBPACK FOOTER //
// ./src/utils/http.js